import React from "react";
import { observer } from "mobx-react";

import { CoachNutritionScreen } from "./screens/CoachNutritionScreen";

export const NutritionCoachEntry = observer(({ coach }) => {
  return <CoachNutritionScreen coach={coach} />;
});
